<template>
    <div class="">
        <ListingTabs
            v-if="tabsField"
            :active-tab="activeFacets[tabsField]"
            :tabs-field="tabsField"
            :scoped-facets="scopedFacets"
            @update-facet="updateFacet($event)"
        />

        <div v-if="loading" class="loading-bar"></div>

        <div class="hidden md:block">
            <ListingSelects
                :active-facets="activeFacets"
                :selects="selectFields"
                :scoped-facets="scopedFacets"
                :active-sort="activeSort"
                :sort-options="sortOptions"
                @update-facet="updateFacet($event)"
                @update-sort="activeSort = $event"
                @clear-facet="updateFacet([$event, undefined])"
            />
        </div>

        <ListingFilterSummary :active-facets="activeFacets" :active-sort-label="activeSortLabel" />

        <ListingDrawer
            :active-facets="activeFacets"
            :selects="selectFields"
            :scoped-facets="scopedFacets"
            :active-sort="activeSort"
            :sort-options="sortOptions"
            @update-facet="updateFacet($event)"
            @update-sort="activeSort = $event"
            @clear-facet="updateFacet([$event, undefined])"
        />

        <div class="container pt-14">
            <div class="flex flex-wrap -mx-1">
                <div
                    v-for="(item, i) in sortedScopedItems"
                    :key="i"
                    class="w-1/2 px-1 pb-2 lg:w-1/4"
                >
                    <RetailCard
                        :title="item.title"
                        :image-url="item.imageUrl"
                        :model-number="item.modelNumber"
                        :price-formatted="item.priceFormatted"
                        :member-price-formatted="item.memberPriceFormatted"
                        class="h-full"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import uniqBy from 'lodash/uniqBy';
import ListingSelects from '@/vue/containers/Listing/ListingSelects';
import ListingTabs from '@/vue/containers/Listing/ListingTabs';
import ListingDrawer from '@/vue/containers/Listing/ListingDrawer';
import ListingFilterSummary from '@/vue/containers/Listing/ListingFilterSummary';
import RetailCard from '@/vue/components/RetailCard';

export default {
    components: {
        RetailCard,
        ListingSelects,
        ListingTabs,
        ListingDrawer,
        ListingFilterSummary
    },

    props: {
        endpoint: {
            type: String,
            required: true
        },
        facets: {
            type: Array,
            default: () => []
        },
        tabsField: {
            type: String,
            default: ''
        },
        tabsDefault: {
            type: String,
            default: ''
        },
        selectFields: {
            type: Array,
            default: () => []
        },
        sortDefault: {
            type: String,
            default: null
        }
    },

    data: () => ({
        items: [],
        loading: false,
        activeFacets: {},
        activeSort: null,
        sortOptions: [
            {
                label: 'Newest First',
                value: 'createdAt'
            },
            {
                label: 'Price (desc)',
                value: 'price',
                invert: true
            }
        ]
    }),

    computed: {
        scopedItems() {
            return Object.keys(this.activeFacets).reduce(
                (items, facet) => {
                    if (!this.activeFacets[facet]) return items;
                    return items.filter((item) => {
                        return item[facet].find((obj) => obj.value === this.activeFacets[facet]);
                    });
                },
                [...this.items]
            );
        },

        sortedScopedItems() {
            const sortBy = this.activeSort;
            if (!sortBy) return this.scopedItems;
            const sorted = [...this.scopedItems].sort((a, b) => (a[sortBy] < b[sortBy] ? 1 : -1));
            return sortBy.invert ? sorted.reverse() : sorted;
        },

        scopedFacets() {
            return this.scopedItems.reduce((acc, item) => {
                this.facets.forEach((facet) => {
                    acc[facet] = acc[facet] ? [...acc[facet], ...item[facet]] : item[facet];
                    acc[facet] = uniqBy(acc[facet], 'id');
                });
                return acc;
            }, {});
        },

        activeSortLabel() {
            return this.activeSort
                ? this.sortOptions.find((option) => option.value === this.activeSort).label
                : '';
        }
    },

    mounted() {
        this.loading = true;
        axios.get(`/api-marketing/${this.endpoint}.json`).then((response) => {
            this.items = response.data.data;
            this.setDefaults();
            this.filterByUrlParams();
            this.loading = false;
        });
    },

    methods: {
        updateFacet([facet, value]) {
            this.$set(this.activeFacets, facet, value);
        },
        setDefaults() {
            this.updateFacet([this.tabsField, this.tabsDefault]);
            this.activeSort = this.sortDefault;
        },
        filterByUrlParams() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            this.facets.forEach((facet) => {
                const validFacet = this.scopedFacets[facet].find((item) => {
                    return item.value === urlParams.get(facet);
                });
                const value = validFacet ? validFacet.value : this.activeFacets[facet];
                this.updateFacet([facet, value]);
            });
        }
    }
};
</script>
